import React, { useContext, useState } from "react";

import {
  MenuOutlined,
  QrcodeOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { downArrow, upArrow } from "../Common/SvgIcon";
import { swipeUparrow, swipeDown1 } from "../Common/SvgIcon";
import {
  defaultBackgroundImage,
  defaultProfileImage,
} from "../Common/DefaultImage";
import { FloatButton } from "antd";
import { FaExchangeAlt, FaLocationArrow } from "react-icons/fa";
// import QRModal from "../Common/QRModal";
import HighlightImage from "../Common/highlightImagesCards/HighlightImage";
import SlideSocialMedia from "../Common/socialMedia/SlideSocialMedia";
import { HighlightImageValid, SocialMediaValid } from "../Common/DivValidation";
import { Link } from "react-router-dom";
import ProfileCardUltra from "../Common/profileCards/ProfileCardUltra";
import ProfileCardGlassy from "../Common/profileCards/ProfileCardGlassy";
import WebsiteUltra from "../Common/websiteCards/WebsiteUltra";
import ReviewCardUltra from "../Common/reviewCards/ReviewCardUltra";
import DownloadCardUltra from "../Common/fileDownloadsCards/DownloadCardUltra";
import ContactCardGlassy from "../Common/contactCards/ContactCardGlassy";
import SlideSocialMedias from "../Common/socialMedia/SlideSocialMedias";
import WebsiteBasic from "../Common/websiteCards/WebsiteBasic";
import VerticalSlideSMVex from "../Common/socialMedia/VerticalSlideSMVex";
import ReviewCardBasic from "../Common/reviewCards/ReviewCardBasic";
import ContactCard1 from "../Common/contactCards/ContactCard1";
import DownloadBasic from "../Common/fileDownloadsCards/DownloadBasic";
import ProfileCardPrism from "../Common/profileCards/ProfileCardPrism";
import ContactCardPrism from "../Common/contactCards/ContactCardPrism";
import HorsizontalscrollGlassy from "../Common/socialMedia/HorsizontalscrollGlassy";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import { CardContext } from "../../store/CardContext";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import { IoIosArrowForward } from "react-icons/io";
import Filesimg from "../../../assests/img/files-img.svg";
import { TbArrowsExchange } from "react-icons/tb";
import { FaUser } from "react-icons/fa";
import { IoShareSocialOutline } from "react-icons/io5";
import { IoCloseOutline, IoLink } from "react-icons/io5";
import { BsQrCodeScan } from "react-icons/bs";
import SlideSocialMediaStd from "../Common/socialMedia/SlideSocialMediaStd";
import SlideSocialMediaStandard from "../Common/socialMedia/SlideSocialMediaStandard";
import ProfileCardIconic from "../Common/profileCards/ProfileCardIconic";
import { RiDirectionLine } from "react-icons/ri";
import Website from "../Common/websiteCards/Website";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";
import ContactCardStd from "../Common/contactCards/ContactCardStd";
import ReviewCardStd from "../Common/reviewCards/ReviewCardStd";
import DownloadCardStd from "../Common/fileDownloadsCards/DownloadCardStd";
import WebsiteStd from "../Common/websiteCards/WebsiteStd";
// import SlideSocialMedias from '../Common/socialMedia/SlideSocialMedias';
function AtlasTheme({ color, preview, card,iconColor }) {
  const [showFirstGallery, setShowFirstGallery] = useState(true);
  const [showSecondGallery, setShowSecondGallery] = useState(false);
  const [expandedDesign, setExpandedDesign] = useState(false);
  const shareMail = (e) => {
    window.location = `mailto:${card?.email}`;
    e.preventDefault();
  };

  const shareMail2 = (e) => {
    window.location = `mailto:${card?.secondaryEmail}`;
    e.preventDefault();
  };
  // Function to toggle the visibility of galleries
  const toggleGalleries = () => {
    setShowFirstGallery(!showFirstGallery);
    setShowSecondGallery(!showSecondGallery);
    setExpandedDesign(!expandedDesign);
  };
  const [showGalleryatlas, setShowGalleryatlas] = useState(false);

  const toggleGalleryatlas = () => {
    setShowGalleryatlas(!showGalleryatlas);
  };
  const [cardData] = useContext(CardContext)
  console.log(cardData);
  const [isOpen, setIsOpen] = useState(false);

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };
  const {
    profileImage,
    backgroundImage,
    personalDetails,
    checkProfile,
    contactDetails,
    socialMedias,
    website,
    review,
    fileName,
    files,

    SMediaPostion,
    companyLogo,
    checkLogo,
    vCard,
    checkExchangeContact,
    exchangeContact,
    checkPfCard,

    footerText
  } = cardData

  const headlines = card?.headlines


  const [isExpanded, setIsExpanded] = useState(false);
  const [qrModal, setQrModal] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const handleClose = (e) => {
    setQrModal(false);
  };


  const HighlightImageCheck = HighlightImageValid();
  const SocialMediaImageCheck = SocialMediaValid();
  const Textcolor = card?.textColor ? card?.textColor : "#000000";;
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#F8F8F8";
  // const BgColor = card?.bgColor ? card?.bgColor : "";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#FFFFFF";



  const BgColor = card?.bgColor ? card?.bgColor : "#FFFFFF";
  const Highlightcolor = card?.colorCode ? card?.colorCode : "#000000";


  const pfImage =
    profileImage[0]?.thumbUrl && profileImage[0]?.status !== "removed"
      ? profileImage[0]?.originFileObj?.type
        ? URL.createObjectURL(profileImage[0]?.originFileObj)
        : profileImage[0].thumbUrl
      : defaultProfileImage;

 

  const exchangeButton = (
    <button
      className="flex justify-center items-center text-[12px] p-2 gap-3 h-[45px] rounded-[6px] w-full"
      style={{
        border: `2px solid ${Highlightcolor || "black"}`,
        color: Highlightcolor || "black",
      }}
    >
      <TbArrowsExchange className="w-4 h-4" />
      Exchange Contacts
    </button>
  )
  function isDarkColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
  }

  const directionButton = (
    <button
      // onClick={onClick}
      className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
      style={{
        backgroundColor: Highlightcolor || "black",
        color: isDarkColor(Highlightcolor) ? "white" : "black",
      }}
    >
      <RiDirectionLine
        className="mr-2"
        size={18}
      
      />
      <span className="font-medium text-[12px]" >
        Directions
      </span>
    </button>
  )

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };
  // const imageStyle = {
  //   backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
  //   backgroundPosition: "center 150px",
  //   backgroundImage: `url(${card?.bgImg})`,
  //   backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  // };
  const imageStyle = {
    backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
    backgroundPosition: "center",
    backgroundImage: `url(${card?.bgImg})`,
    backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",

  };
  const colorStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundColor: BgColor,
  };
  const defaultStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center 150px",
    backgroundImage: 'white'
  };
  return (
    <>
      <div className="digitalcontainer6">
        <div className="digitalcontainer_center6">
          <div
            className="digitalcontainer_banner6 relative h-screen overflow-auto scrollbar-hide  "
          
          >

            <div className="w-full h-[400px] overflow-hidden">
              {/* {profileImage[0]?.thumbUrl &&
                profileImage[0]?.status !== "removed" ? (
                <img
                  className="sticky top-0 w-full h-full object-cover"
                  src={
                    profileImage[0]?.originFileObj?.type
                      ? URL.createObjectURL(profileImage[0]?.originFileObj)
                      : profileImage[0].thumbUrl
                  }
                  alt=""
                />
              ) : (
                <img
                  className="sticky w-full h-full object-cover"
                  src={defaultProfileImage}
                  alt=""
                  style={{ borderRadius: "30px" }}
                />
              )} */}
              <img
                className=' w-full h-full object-cover'
                src={profileImage ? profileImage : defaultProfileImage}
                alt=""
              // style={{ borderRadius: '30px' }}
              />
            </div>
            
            {card?.companyLogo && card?.checkLogo && (
                <div
                  className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full"
                  style={{
                    padding: "4px",
                    backgroundColor: Highlightcolor
                      ? `${Highlightcolor}`
                      : "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <img
                    src={card?.companyLogo}
                    alt="Company Logo"
                    className="object-cover rounded-full w-full h-full"
                  />
                </div>
              )}
            <div className="absolute top-72 rounded-t-[20px] bg-white" style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}>
              <div className="mt-5">
                <p className="text-center tracking-normal  m-0 text-[24px] font-bold" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {personalDetails?.name ? personalDetails.name : ""}
                </p>

                <p className="text-[12px] font-normal text-white mt-2 text-center"  style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {personalDetails?.companyDesignation
                    ? personalDetails.companyDesignation
                    : ""}
                </p>

              </div>
              <div className="flex justify-center gap-4 w-full mb-5 mt-4">
                <Link
                  onClick={() => handleTap('saveContact')}
                  to={`${preview ? vCard : ""}`}
                  // target={`${preview ? "_blank" : ""}`}
                  className="blk-btn w-1/2"
                >
                  <button
                    className="flex justify-center items-center p-2 text-[12px] gap-2 h-[45px] rounded-[6px] w-full"
                    style={{
                      background: Highlightcolor || "black",
                    }}
                  >
                   <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 8C9.29493 8 10.75 6.54493 10.75 4.75C10.75 2.95507 9.29493 1.5 7.5 1.5C5.70507 1.5 4.25 2.95507 4.25 4.75C4.25 6.54493 5.70507 8 7.5 8Z"        stroke={isDarkColor(Highlightcolor) ? "white" : "black"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.68 14.5C13.2602 13.1908 12.4355 12.0488 11.3248 11.2386C10.2141 10.4284 8.8748 9.99182 7.5 9.99182C6.1252 9.99182 4.78591 10.4284 3.67522 11.2386C2.56453 12.0488 1.73982 13.1908 1.32 14.5H13.68Z" stroke={isDarkColor(Highlightcolor) ? "white" : "black"}  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                    <span
                      className="text-[12px]"
                      style={{
                        color: isDarkColor(Highlightcolor) ? "white" : "black",
                      }}
                    >
                      Add to contacts
                    </span>
                  </button>
                </Link>
                {card?.exchangeContact?.show ?
                  <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
                  : ""
                }

              </div>
              {/* ------------------------------- about ------------------------------- */}

              {card?.about ? (
                <div className="px-4">
                  <div className="flex">
                    <h2 className="font-semibold  text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                      About {card?.aboutHeadline ? card?.aboutHeadline : ""}
                    </h2>

                  </div>
                  <div className="about whitespace-pre-line mt-2" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>{card?.about}</div>
                </div>
              ) : (
                ""
              )}
              {/* ------------------------------- conatct ------------------------------- */}

              <div className="flex mt-5 px-4">
                <h2 className="font-semibold text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {/* Contact Info */}
                  {headlines?.contactHeadline ? headlines?.contactHeadline : 'Contact Info'}
                </h2>

              </div>

              <div className="mb-2  px-3">

                <ContactCardStd preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} customButton={directionButton} />

              </div>
              {/* ------------------------------- social ------------------------------- */}

              {SocialMediaImageCheck ||
                (card?.socialMedias && card?.socialMedias?.length !== 0) ? (
                <>
                  <div className="flex mt-5 px-5">
                    <h2 className="font-semibold  text-[16px] mb-4" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                      {/* Social media  */}
                      {headlines?.socialMediaHeadline ? headlines?.socialMediaHeadline : 'Social Media'}
                    </h2>

                  </div>
                  {/* <SlideSocialMediaStd preview={preview} color={'black'} Highlightcolor={Highlightcolor} /> */}
                  {card?.socialMedias && card?.socialMedias?.length !== 0 ? (
                    <SlideSocialMediaStandard
                      preview={preview}
                      Iconcolor={Iconcolor}
                      Highlightcolor={Highlightcolor}
                      theme={"modern"}
                      BtIColor={BtIColor}
                      Textcolor={Textcolor}
                    />
                  ) : (
                    <SlideSocialMediaStd
                      preview={preview}
                      Iconcolor={Iconcolor}
                      Highlightcolor={Highlightcolor}
                      theme={"modern"}
                      iconColor=  {iconColor = color ? color : '#000000'} 
                    />
                  )}
                </>
              ) : (
                ""
              )}

              {/* ------------------------------- website ------------------------------- */}

              {(card?.website ? card?.website[0]?.websiteName : '') ? (
                <div className="px-5 ">
                  <div className="flex mt-7 pb-4">
                    <h2 className="font-semibold  text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                      {/* Website */}
                      {headlines?.websiteHeadline ? headlines?.websiteHeadline : 'Website'}
                    </h2>

                  </div>
                  {/* <Website website={website} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} /> */}
                  <WebsiteStd  website={website} preview={preview} Textcolor={Textcolor} Highlightcolor={Highlightcolor} Iconcolor={Iconcolor} BtIColor={BtIColor} />

                </div>
              ) : (
                ""
              )}

{card?.reviews ? (
                card?.reviews[0]?.reviewName ? (
                  <div
                    className="contactOptions3 px-5"
                  // style={{
                  //   color: `${Textcolor ? Textcolor : ""}`,
                  //   backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                  // }}
                  >
                    {/* <h4>Review</h4> */}
                    <div className="flex mb-3 items-center gap-2">
                      <p className="font-semibold  text-[16px] " style={{
                        color: `${Textcolor ? Textcolor : ""}`,
                      }}>
                        {/* Review */}
                        {headlines?.reviewHeadline ? headlines?.reviewHeadline : 'Review'}

                      </p>

                    </div>
                    <ReviewCardStd reviews={card?.reviews} preview={preview} Textcolor={Textcolor} BtIColor={BtIColor} />

                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {/* ------------------------------- files ------------------------------- */}

              {card?.files?.file1?.fileName ||
                card?.files?.file2?.fileName ||
                card?.files?.file3?.fileName ||
                card?.files?.file4?.fileName ? (
                <div className="px-5">
                  <div className="flex  mt-8 mb-3 items-center gap-2">
                    <p className="font-semibold  text-[16px]" style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}>
                      {/* Attachments */}
                      {headlines?.filesHeadline ? headlines?.filesHeadline : 'Attachments'}
                    </p>

                  </div>
                  <div className="contactOptions2 relative">

                    <DownloadCardStd
                      preview={preview}
                      fileName={fileName}
                      files={files}
                      BtIColor={BtIColor}
                      Textcolor={Textcolor}
                      Iconcolor={Iconcolor}
                    />

                  </div>
                </div>
              ) : (
                ""
              )}

              {/* ------------------------------- review ------------------------------- */}


              {/* ------------------------------- gallery ------------------------------- */}

              {card?.highlightPhotos[0].highlightPhotos1 ||
                card?.highlightPhotos[0].highlightPhotos2 ||
                card?.highlightPhotos[0].highlightPhotos3 ||
                card?.highlightPhotos[0].highlightPhotos4 ||
                card?.highlightPhotos[0].highlightPhotos5 ||
                card?.highlightPhotos[0].highlightPhotos6 ||
                card?.highlightPhotos[0].highlightPhotos7 ||
                card?.highlightPhotos[0].highlightPhotos8 ? (
                card?.checkHighlight ? (
                  <div className="px-5">
                    <div className="flex mt-3">
                      <h2 className="font-semibold   text-[16px]" style={{ color: `${Textcolor ? Textcolor : "black"}` }}>Gallery</h2>

                    </div>
                    <div>
                      <HighlightImage />
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              
              {footerText &&
                <div className="mt-10">
                  <Footer color={Textcolor} />
                </div>
              }

            </div>


            {preview ? (
              <div className="fixed bottom-0 right-7 z-10 space-y-4">
                {!isOpen && (
                  <div className="relative group">
                    <div className="flex items-center space-x-2">
                      <span
                        className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                        style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                      >
                        Share
                      </span>
                      <button
                        onClick={toggleButtons}
                        className="border rounded-full p-2 bg-blue-500 hover:bg-blue-600 transition-transform duration-[1s] ease-in-out"
                        style={{
                          backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                          borderColor: `${Highlightcolor ? Highlightcolor : ""}`
                        }}
                      >
                        <IoShareSocialOutline size={23} color={iconColor} />
                      </button>
                    </div>
                  </div>
                )}

                {isOpen && (
                  <>
                    {/* Profile Link Button */}
                    <div
                      className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                        }`}
                      style={{ transitionDelay: '0.1s' }}
                    >
                      <div className="flex items-center space-x-2">
                        <span
                          className="absolute -left-24 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                          style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                        >
                          Profile Link
                        </span>
                        <button
                          onClick={handleShare}
                          className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out"
                          style={{ color: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}

                        >
                          <IoLink size={23} />
                        </button>
                      </div>
                    </div>

                    {/* QR Code Button */}
                    <div
                      className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                        }`}
                      style={{ transitionDelay: '0.2s' }}
                    >
                      <div className="flex items-center space-x-2">
                        <span
                          className="absolute -left-16 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                          style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                        >
                          QR Code
                        </span>
                        <button
                          onClick={() => setQrModal(true)}
                          className="border-[1px] rounded-full p-2 bg-transparent transition-transform duration-[1s] ease-in-out" style={{ borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                        >
                          <BsQrCodeScan size={23} style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }} />
                        </button>
                      </div>
                    </div>

                    {/* Close Button */}
                    <div
                      className={`relative group transition-transform duration-[1s] ease-in-out ${isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                        }`}
                      style={{ transitionDelay: '0.3s' }}
                    >
                      <div className="flex items-center space-x-2">
                        <span
                          className="absolute -left-12 opacity-0 group-hover:opacity-100 transition-opacity duration-[1s] ease-in-out text-[12px]"
                          style={{ color: `${Highlightcolor ? Highlightcolor : ""}` }}
                        >
                          Close
                        </span>
                        <button
                          onClick={toggleButtons}
                          className="border rounded-full p-2 text-white cursor-pointer transition-transform duration-[1s] ease-in-out"
                          style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`, borderColor: `${Highlightcolor ? Highlightcolor : ""}` }}
                        >
                          <IoCloseOutline size={23} color={iconColor} />
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              // <div className="flex justify-center gap-[20px] fixed top-[90%] lg:left-[45%] left-[35%]   ">
              //   <button
              //     className="w-[50px] h-[50px] flex justify-center p-[15px] rounded-[12px] shadow bg-white"
              //     onClick={handleShare}
              //   >
              //     <svg
              //       width="24"
              //       height="24"
              //       viewBox="0 0 24 24"
              //       fill="none"
              //       xmlns="http://www.w3.org/2000/svg"
              //     >
              //       <path
              //         d="M18 22C17.1667 22 16.4583 21.7083 15.875 21.125C15.2917 20.5417 15 19.8333 15 19C15 18.8833 15.0083 18.7623 15.025 18.637C15.0417 18.5117 15.0667 18.3993 15.1 18.3L8.05 14.2C7.76667 14.45 7.45 14.646 7.1 14.788C6.75 14.93 6.38333 15.0007 6 15C5.16667 15 4.45833 14.7083 3.875 14.125C3.29167 13.5417 3 12.8333 3 12C3 11.1667 3.29167 10.4583 3.875 9.875C4.45833 9.29167 5.16667 9 6 9C6.38333 9 6.75 9.071 7.1 9.213C7.45 9.355 7.76667 9.55067 8.05 9.8L15.1 5.7C15.0667 5.6 15.0417 5.48767 15.025 5.363C15.0083 5.23833 15 5.11733 15 5C15 4.16667 15.2917 3.45833 15.875 2.875C16.4583 2.29167 17.1667 2 18 2C18.8333 2 19.5417 2.29167 20.125 2.875C20.7083 3.45833 21 4.16667 21 5C21 5.83333 20.7083 6.54167 20.125 7.125C19.5417 7.70833 18.8333 8 18 8C17.6167 8 17.25 7.92933 16.9 7.788C16.55 7.64667 16.2333 7.45067 15.95 7.2L8.9 11.3C8.93333 11.4 8.95833 11.5127 8.975 11.638C8.99167 11.7633 9 11.884 9 12C9 12.1167 8.99167 12.2377 8.975 12.363C8.95833 12.4883 8.93333 12.6007 8.9 12.7L15.95 16.8C16.2333 16.55 16.55 16.3543 16.9 16.213C17.25 16.0717 17.6167 16.0007 18 16C18.8333 16 19.5417 16.2917 20.125 16.875C20.7083 17.4583 21 18.1667 21 19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22Z"
              //         fill="black"
              //       />
              //     </svg>
              //   </button>
              //   <button
              //     className="w-[50px] h-[50px] flex justify-center shadow p-[10px] rounded-[12px] bg-white"
              //     onClick={() => setQrModal(true)}
              //   >
              //     <svg
              //       width="34"
              //       height="34"
              //       viewBox="0 0 34 34"
              //       fill="none"
              //       xmlns="http://www.w3.org/2000/svg"
              //     >
              //       <path
              //         d="M4.25 9.20833C4.25 7.8933 4.77239 6.63213 5.70226 5.70226C6.63213 4.77239 7.8933 4.25 9.20833 4.25H11.849C12.2247 4.25 12.5851 4.39926 12.8507 4.66493C13.1164 4.93061 13.2657 5.29094 13.2657 5.66667C13.2657 6.04239 13.1164 6.40272 12.8507 6.6684C12.5851 6.93408 12.2247 7.08333 11.849 7.08333H9.20833C8.64475 7.08333 8.10425 7.30722 7.70573 7.70573C7.30722 8.10425 7.08333 8.64475 7.08333 9.20833V11.849C7.08333 12.2247 6.93408 12.5851 6.6684 12.8507C6.40272 13.1164 6.04239 13.2657 5.66667 13.2657C5.29094 13.2657 4.93061 13.1164 4.66493 12.8507C4.39926 12.5851 4.25 12.2247 4.25 11.849V9.20833ZM20.7343 5.66667C20.7343 5.29094 20.8836 4.93061 21.1493 4.66493C21.4149 4.39926 21.7753 4.25 22.151 4.25H24.7917C26.1067 4.25 27.3679 4.77239 28.2977 5.70226C29.2276 6.63213 29.75 7.8933 29.75 9.20833V11.849C29.75 12.2247 29.6007 12.5851 29.3351 12.8507C29.0694 13.1164 28.7091 13.2657 28.3333 13.2657C27.9576 13.2657 27.5973 13.1164 27.3316 12.8507C27.0659 12.5851 26.9167 12.2247 26.9167 11.849V9.20833C26.9167 8.64475 26.6928 8.10425 26.2943 7.70573C25.8958 7.30722 25.3553 7.08333 24.7917 7.08333H22.151C21.7753 7.08333 21.4149 6.93408 21.1493 6.6684C20.8836 6.40272 20.7343 6.04239 20.7343 5.66667ZM5.66667 20.7343C6.04239 20.7343 6.40272 20.8836 6.6684 21.1493C6.93408 21.4149 7.08333 21.7753 7.08333 22.151V24.7917C7.08333 25.3553 7.30722 25.8958 7.70573 26.2943C8.10425 26.6928 8.64475 26.9167 9.20833 26.9167H11.849C12.2247 26.9167 12.5851 27.0659 12.8507 27.3316C13.1164 27.5973 13.2657 27.9576 13.2657 28.3333C13.2657 28.7091 13.1164 29.0694 12.8507 29.3351C12.5851 29.6007 12.2247 29.75 11.849 29.75H9.20833C7.8933 29.75 6.63213 29.2276 5.70226 28.2977C4.77239 27.3679 4.25 26.1067 4.25 24.7917V22.151C4.25 21.7753 4.39926 21.4149 4.66493 21.1493C4.93061 20.8836 5.29094 20.7343 5.66667 20.7343ZM28.3333 20.7343C28.7091 20.7343 29.0694 20.8836 29.3351 21.1493C29.6007 21.4149 29.75 21.7753 29.75 22.151V24.7917C29.75 26.1067 29.2276 27.3679 28.2977 28.2977C27.3679 29.2276 26.1067 29.75 24.7917 29.75H22.151C21.7753 29.75 21.4149 29.6007 21.1493 29.3351C20.8836 29.0694 20.7343 28.7091 20.7343 28.3333C20.7343 27.9576 20.8836 27.5973 21.1493 27.3316C21.4149 27.0659 21.7753 26.9167 22.151 26.9167H24.7917C25.3553 26.9167 25.8958 26.6928 26.2943 26.2943C26.6928 25.8958 26.9167 25.3553 26.9167 24.7917V22.151C26.9167 21.7753 27.0659 21.4149 27.3316 21.1493C27.5973 20.8836 27.9576 20.7343 28.3333 20.7343ZM14.1667 9.91667H9.91667V14.1667H14.1667V19.8333H9.91667V24.0833H14.1667V19.8333H19.8333V24.0833H24.0833V19.8333H19.8333V14.1667H24.0833V9.91667H19.8333V14.1667H14.1667V9.91667Z"
              //         fill={Highlightcolor ? Highlightcolor : "black"}
              //       />
              //     </svg>
              //   </button>

              //   {card?.exchangeContact?.show ?
              //     <ExchangeContact customButton={exchangeButton} details={card?.exchangeContact} cardId={card._id} />
              //     : ""
              //   }

              // </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {qrModal ? <QRModal handleClose={handleClose} /> : null}
      </div>
    </>
  );
}

export default AtlasTheme;
